import { render, staticRenderFns } from "./RebateTitle.vue?vue&type=template&id=5131e575&scoped=true"
import script from "./RebateTitle.vue?vue&type=script&lang=js"
export * from "./RebateTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131e575",
  null
  
)

export default component.exports